import { useEffect, useState } from 'react'
import { api } from 'core/api/ConnectionManager'

export interface IPermissionsProps {
    selectedInfo: { id: number } | null
    closeModal: () => void
}

interface IState {
    permissions: string[] | null
    isUnknownPermissions: boolean
    isLoading: boolean
    requestPermissions: { [index: string]: boolean }
    isRequestAll: boolean
}

let getPermissionsTimer: any = null

const DisplaysPermissionsMethods = (p_: IPermissionsProps) => {
    const [state, setState] = useState<IState>({
        permissions: null,
        isUnknownPermissions: false,
        isLoading: true,
        requestPermissions: {},
        isRequestAll: false,
    })

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver('getDisplayAndroidPermissions', onGetDisplayAndroidPermissions, listenersId)

        getPermissions()

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))

            clearInterval(getPermissionsTimer)
        }
    }, [])

    const onGetDisplayAndroidPermissions = (res: { permissions: string[] }) => {
        clearTimeout(getPermissionsTimer)
        setState((prevState) => {
            return {
                ...prevState,
                isLoading: false,
                permissions: res.permissions,
                isRequestAll: false,
            }
        })
    }

    const getPermissions = () => {
        getPermissionsTimer = setTimeout(() => {
            setState((prevState) => {
                return {
                    ...prevState,
                    isUnknownPermissions: true,
                    isLoading: false,
                }
            })
        }, 10000)

        setState((prevState) => {
            return {
                ...prevState,
                isLoading: true,
            }
        })

        setTimeout(() => {
            const id = p_.selectedInfo && p_.selectedInfo.id

            if (id) {
                api.send('getDisplayAndroidPermissions', { id }, { hideLoader: true })
            }
        }, 200)
    }
    const requestPermission = (permission: string) => {
        const s_ = { ...state }

        s_.requestPermissions[permission] = true

        setState((prevState) => {
            return {
                ...prevState,
                ...s_,
            }
        })

        setTimeout(() => requestPermissions(permission), 200)
    }

    const requestPermissions = (permissions: string) => {
        const id = p_.selectedInfo && p_.selectedInfo.id

        if (id) {
            api.send('requestDisplayAndroidPermissions', { id, permissions })
        }
    }

    return {
        state,
        requestPermission,
    }
}

export default DisplaysPermissionsMethods
